import { z } from "zod";
import { zodSortField } from "@/lib/utils";

const billingCodes = ["FDM", "VN", "FU", "VO", "DA", "CS"] as const;

export const getFacturationRulesRequestSchema = z.object({
  sort: zodSortField([
    "brandNumericCode",
    "brandAlphabeticCode",
    "billingCode",
    "serviceType",
    "articleNumber",
    "createdAt",
  ]).optional(),
});

const facturationRuleBaseSchema = z.object({
  brandNumericCode: z
    .string()
    .trim()
    .regex(/^\d$/, "Le code marque numérique doit contenir 1 chiffre"),
  brandAlphabeticCode: z
    .string()
    .trim()
    .toUpperCase()
    .regex(
      /^[A-Z]$/,
      "Le code marque alphabétique doit contenir 1 lettre majuscule",
    ),
  brandAlphabeticLabel: z
    .string()
    .trim()
    .toUpperCase()
    .regex(
      /^[A-Z ]+$/,
      "Le libellé marque doit être alphabétique (espaces autorisés)",
    )
    .max(20, "Le libellé marque alphabétique est limité à 20 caractères"),
  billingCode: z.enum(billingCodes, {
    errorMap: () => ({
      message: "Code facturation invalide (FDM, VN, FU, VO, DA, CS)",
    }),
  }),
  serviceType: z
    .string()
    .trim()
    .regex(
      /^[A-Za-z0-9 ]+$/,
      "Le type de service doit être alphanumérique (espaces autorisés)",
    )
    .max(50, "Le type de service est limité à 50 caractères"),
  noticeItemLabel: z
    .string()
    .trim()
    .regex(
      /^[A-Za-z0-9 ]+$/,
      "Le libellé texte poste notice doit être alphanumérique",
    )
    .max(50, "Le libellé texte poste notice est limité à 50 caractères"),
  articleNumber: z
    .string()
    .trim()
    .regex(/^\d{6}$/, "Le numéro d'article doit contenir 6 chiffres"),
  unitCost: z.coerce
    .number()
    .nonnegative("Le coût unitaire doit être positif ou nul")
    .finite("Le coût unitaire est invalide"),
});

export const addFacturationRuleSchema = facturationRuleBaseSchema;

export const editFacturationRuleSchema = facturationRuleBaseSchema.extend({
  id: z.number().int().positive(),
  isActive: z.boolean().default(true),
  versionNote: z.string().max(500).optional(),
});

export const deleteFacturationRuleSchema = z.object({
  id: z.number().int().positive(),
});
